import React from 'react';
import Image from 'next/image';

const languages = ({ dataInputsLanguages }) => (
  <div className="pt-24">
    <h3 className="pb-16 text-4xl font-aeonik">Supported Languages</h3>
    <ul className="grid gap-x-16 gap-y-6 sm:gap-y-10 grid-cols-2 sm:grid-cols-4">
      {dataInputsLanguages.map(({ flag, language }) => (
        <li key={flag} className="flex">
          <Image src={`/static/images/icons/flags/${flag}.svg`} width="24" height="18" alt="" />
          <span className="pl-3">{language}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default languages;
